import { render, staticRenderFns } from "./usm-performance-and-portfolio-bar-chart.vue?vue&type=template&id=5510acde&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports